import React from 'react';
import { Box, Heading, Text, Grid, GridItem, Link } from '@chakra-ui/react';
import SectionTitle from './SectionTitle';

interface MainPostProps {
  image: React.ReactNode;
  title: string;
  slug: string;
  description: string;
}

interface SecondaryPostProps {
  image: React.ReactNode;
  title: string;
  slug: string;
}

const MainPost = ({ image, title, description, slug }: MainPostProps) => (
  <GridItem
    borderWidth="1px"
    borderStyle="solid"
    borderColor="#bab5b5"
    rowSpan={2}
    colSpan={[12, 12, 7]}
    display="flex"
    flexDirection="column"
  >
    <Box display="flex" flex="2">
      {image}
    </Box>
    <Box
      p="7"
      display="flex"
      flex="1"
      flexDirection="column"
      backgroundColor="white"
    >
      <Link href={`/blog/${slug}/`}>
        <Heading size="lg" as="h3">
          {title}
        </Heading>
      </Link>
      <Text mt="3">{description}</Text>
    </Box>
  </GridItem>
);

const SecondaryPost = ({ image, title, slug }: SecondaryPostProps) => (
  <GridItem
    borderWidth="1px"
    borderStyle="solid"
    borderColor="#bab5b5"
    colSpan={[12, 12, 5]}
    display="flex"
    flexDirection={['column', 'column', 'row']}
  >
    <Box flex="1" display="flex">
      {image}
    </Box>
    <Box
      display="flex"
      flex="1"
      justifyContent="center"
      alignItems="center"
      backgroundColor="white"
    >
      <Link href={`/blog/${slug}/`}>
        <Heading fontSize="2xl" p="5" as="h3">
          {title}
        </Heading>
      </Link>
    </Box>
  </GridItem>
);

const FeaturedPosts = ({
  mainPost,
  secondaryPosts,
}: {
  mainPost: MainPostProps;
  secondaryPosts: SecondaryPostProps[];
}) => (
  <Box backgroundColor="#d7d7d7">
    <Box maxW="8xl" mx="auto" p={['5', '14']}>
      <SectionTitle title="Explore More" />
      <Grid
        templateRows={['repeat(4, 1fr)', 'repeat(4, 1fr)', 'repeat(2, 1fr)']}
        templateColumns="repeat(12, 1fr)"
        gap={7}
      >
        <MainPost
          image={mainPost.image}
          title={mainPost.title}
          slug={mainPost.slug}
          description={mainPost.description}
        />

        {secondaryPosts.map(({ image, title, slug }) => (
          <SecondaryPost key={title} title={title} slug={slug} image={image} />
        ))}
      </Grid>
    </Box>
  </Box>
);

export default FeaturedPosts;
